import React, { Component } from 'react'

// Externals
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Typography, withStyles } from '@material-ui/core'
import { ShoppingBasket as ShoppingBasketIcon } from '@material-ui/icons'
import { Paper } from 'components'
import styles from './styles'

class OrderStatus extends Component {
  render () {
    const { classes, className, orders, ...rest } = this.props

    const rootClassName = classNames(classes.root, className)

    return (
      <Paper
        {...rest}
        className={rootClassName}
      >
        <div className={classes.content}>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
              Orders
            </Typography>
            <Typography
              className={classes.value}
              variant='h5'
            >
              {`Today:    ${orders.orders_made || 0}`}
            </Typography>
            <Typography
              className={classes.value}
              variant='h5'
            >
              {`${orders.all_completed || 0} / ${orders.all_orders || 0}`}
            </Typography>
          </div>
          <div className={classes.iconWrapper}>
            <ShoppingBasketIcon className={classes.icon} />
          </div>
        </div>
      </Paper>
    )
  }
}

OrderStatus.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(OrderStatus)
